import setCompsetsUpdatedFlag from '@/utils/setCompsetsUpdatedFlag';
import apiHelper from '@/utils/apiHelper';

const deleteDestination = async (id) => {
  const { status } = await apiHelper(
    'DELETE',
    `/destination-compset/${id}`,
  );

  if ([200, 201].indexOf(status) >= 0) {
    setCompsetsUpdatedFlag(true);
    return true;
  }

  return false;
};

export default deleteDestination;
